import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { UTCToDateTimeFormat } from "../../../../shared";
import { tableColumns } from "../../constants";

export const tableColumnsHeader = (handlePreviewRow) => {
  return [
    {
      name: <span className="fw-bold">From</span>,
      selector: (row) => row.fromJson,
      width: `${tableColumns.SIZE_210}px`,
    },
    {
      name: <span className="fw-bold">To</span>,
      selector: (row) => row.toJson,
      width: `${tableColumns.SIZE_210}px`,
    },
    {
      name: <span className="fw-bold">Subject</span>,
      selector: (row) => row.subject,
      width: `${tableColumns.SIZE_300}px`,
    },
    {
      name: <span className="fw-bold">Added at</span>,
      selector: (row) => UTCToDateTimeFormat(row.createdAt),
      width: `${tableColumns.SIZE_210}px`,
    },
    {
      name: <span className="fw-bold">Action</span>,
      cell: (row) => (
        <div
          title="Preview"
          className="d-flex align-items-center justify-content-center"
        >
          <FontAwesomeIcon
            icon={faEye}
            role="button"
            aria-hidden="true"
            className="font-14-px pt-1 me-2"
            onClick={() => handlePreviewRow(row)}
          />
        </div>
      ),
      width: `${tableColumns.SIZE_150}px`,
      center: true,
    },
  ];
};
